export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">联系投稿</h2>
            <p className="mt-3 text-sm text-foreground-500">有好的影视资源推荐？欢迎联系我们投稿或反馈意见</p>

            <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-600"></i>
                </div>
                <h3 className="mt-4 font-semibold text-foreground-900 text-sm">资源投稿</h3>
                <p className="mt-2 text-xs text-foreground-500">有好的影片资源推荐？<br/>通过邮件发送给我们</p>
                <p className="mt-2 text-sm font-medium text-primary-600">tougao@90cinema.com</p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-bug-line text-xl text-accent-600"></i>
                </div>
                <h3 className="mt-4 font-semibold text-foreground-900 text-sm">问题反馈</h3>
                <p className="mt-2 text-xs text-foreground-500">播放问题或建议？<br/>我们会在24小时内回复</p>
                <p className="mt-2 text-sm font-medium text-accent-600">fankui@90cinema.com</p>
              </div>

              <div className="p-6 rounded-xl bg-background-50 border border-background-200/60 text-center">
                <div className="w-12 h-12 mx-auto rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-shake-hands-line text-xl text-secondary-600"></i>
                </div>
                <h3 className="mt-4 font-semibold text-foreground-900 text-sm">商务合作</h3>
                <p className="mt-2 text-xs text-foreground-500">广告投放或商务合作<br/>期待与您携手共赢</p>
                <p className="mt-2 text-sm font-medium text-secondary-600">hezuo@90cinema.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}